import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/arrow-bottom.png'


const _withScopeId = n => (_pushScopeId("data-v-1ac8c8a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "title text-center" }
const _hoisted_4 = { class: "current-have-point" }
const _hoisted_5 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_6 = { class: "label" }
const _hoisted_7 = { class: "number" }
const _hoisted_8 = {
  key: 0,
  class: "text-container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, " リサイクルプログラムを通じて、テラサイクルポイントを獲得できます。 ", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 各プログラムの規定に従い、回収協力者は学校やNPO等に寄付などが可能なテラサイクルポイントを獲得できます。これまで世界中で4,500万米ドル以上のテラサイクルポイントが回収協力者に付与されています。 ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 複数のプログラムに参加された場合でも、プログラムごとにテラサイクルポイントは付与されます。 ", -1))
const _hoisted_12 = [
  _hoisted_9,
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "text-container"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, " Earn TerraCycle rewards points automatically by recycling with participating programs. ", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " For each valid shipment you send in, you will earn points that can be redeemed for a donation to your school, favorite non-profit organization, or the charity of your choice. To date, we’ve raised over $45 million globally. ", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", {
  class: "title",
  style: {"margin-bottom":"0"}
}, " Remember ", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("div", null, "• You can be in more than one free recycling program, so feel free to sign up for as many as you would like."),
  /*#__PURE__*/_createElementVNode("div", null, "• Anyone within the contiguous United States can participate in our national recycling programs. Just make sure to check the specificqualifications of each individual program.")
], -1))
const _hoisted_18 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { class: "dedeem-wrapper" }
const _hoisted_20 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = { class: "filter-wrapper" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon"
}, null, -1))
const _hoisted_24 = { class: "points-wrapper row" }
const _hoisted_25 = { class: "item" }
const _hoisted_26 = ["src", "onClick"]
const _hoisted_27 = { class: "content-wrapper" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "d-flex justify-content-between" }
const _hoisted_30 = { class: "point-number" }
const _hoisted_31 = { class: "number" }
const _hoisted_32 = {
  key: 0,
  class: "text-container"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, " 寄付先データベース ", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 下記のデーターベースに登録済みの団体であれば、2500ポイントから寄付が可能です。ご希望の寄付先があるかまずは検索をお願いします。もしデーターベースにご希望の寄付先がない場合は、新たに寄付先として登録申請していただくことも可能ですが、その場合は当社にて審査をさせていただき、審査通過後に寄付が可能となります ", -1))
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "text-container"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, " Charity Database ", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " Your TerraCycle Recycling Rewards points may be redeemed as a donation to the school, charity, or non-profit of your choice. Explore our database, or request that a new organization be added. ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " Please note, you must redeem a minimum of 2,500 TerraCycle points (or $25), or check out how you can support one of our highlighted charity partners above. ", -1))
const _hoisted_40 = [
  _hoisted_37,
  _hoisted_38,
  _hoisted_39
]
const _hoisted_41 = { class: "text-container" }
const _hoisted_42 = { class: "title" }
const _hoisted_43 = { class: "search-wrapper" }
const _hoisted_44 = {
  class: "row text",
  style: {"--bs-gutter-y":"0.5rem"}
}
const _hoisted_45 = {
  key: 0,
  class: "col-12"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " ご希望の寄付先（チャリティ）が検索で見つからなかった場合、ご自身で新たな寄付先を登録することも可能です ", -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = {
  key: 1,
  class: "col-12 col-md-9 col-xl-10"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " If you were not able to find your charity, you have the option to add your own. Before adding a new charity, please read these guidelines: ", -1))
const _hoisted_50 = /*#__PURE__*/_createTextVNode(" Learn More ")
const _hoisted_51 = {
  key: 2,
  class: "text-container"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, " 注意事項 ", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 寄付金が実際に各団体に支払われるのは6月と12月のいずれかのタイミングとなります。11月1日から4月末までに交換していただいた申請分は6月末までに、5月1日から10月末までに申請いただいた分については、12月末までに支払い処理されます。 ", -1))
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = {
  key: 3,
  class: "text-container"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, " Please Note ", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, " We have two payment periods per year. If you redeem by the end of April, your charity will be paid in June. If you redeem by the end of October, your charity will be paid in January. ", -1))
const _hoisted_58 = [
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = { class: "dialog-wrapper" }
const _hoisted_60 = {
  class: "d-flex justify-content-center align-items-center",
  style: {"margin":"1.25rem 0 1rem"}
}
const _hoisted_61 = { class: "promary" }
const _hoisted_62 = { class: "text-content" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = /*#__PURE__*/_createTextVNode(" ポイントを交換しています ")
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" You are redeeming ")
const _hoisted_66 = /*#__PURE__*/_createTextVNode(" points for ")
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Protect one acre of rainforest for one year", -1))

import { ref, reactive, onMounted, computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import SearchCharity from './components/search-charity.vue';
  import { ColorVariants } from '@/constants';
  import { authStore, Collection, settingStore } from '@/stores';
  import { request, alert } from '@/utils';
  import { ICharity } from '@/types/charity';
  import { useToast } from 'bootstrap-vue-3';
  import { PrizeCategory, getPdoDefaultPrizeCategory, Prize, getPdoDefaultPrize } from '@/types/prize';
  import Charity from './components/charity.vue';


  interface PrizeCategoryStore extends Collection {
    data: PrizeCategory[];
  }
  interface PrizeStore extends Collection {
    data: Prize[];
  }

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const { t, locale } = useI18n();
  const toast = useToast();
  const dialogContent = reactive({
    show: false
  });

  const currentPrizeCategory = reactive(getPdoDefaultPrizeCategory());
  const prizeCategoryStore = Collection.create<PrizeCategoryStore>({
    fetch(params = {}) {
      return request.get('/prize_categories', { params: { ...params, page: 0 } });
    }
  });
  const currentPrize = reactive(getPdoDefaultPrize());
  const prizeStore = Collection.create<PrizeStore>({
    fetch(params = {}) {
      return request.get('/prizes', { params: { ...params, page: 0 } });
    }
  });

  const breadcurmbRoutes = [
    {
      name: t('Home'),
      to: { name: 'home' }
    },
    {
      name: t('TerraCycle Recycling Rewards')
    }
  ];

  const pointUsage = computed(() => {
    const companyAccount = authStore.user.company_account;
    if (!companyAccount || companyAccount.role !== 'store_sub') {
      return true;
    }
    return authStore.user.point_usage;
  });

  function handleShowPopup(data: Prize) {
    Object.assign(currentPrize, data);
    dialogContent.show = true;
  }

  async function updatePrize() {
    prizeStore.params.prize_category_id_eq = currentPrizeCategory.id;
    prizeStore.fetchData();
  }

  function handleChangeCategory(item: PrizeCategory) {
    if (item.id === currentPrizeCategory.id) {
      return;
    }
    Object.assign(currentPrizeCategory, item);
    updatePrize();
  }

  function handlePrizeJump(prize: Prize) {
    if (!prize.partner_url) {
      return;
    }
    window.open(prize.partner_url);
  }

  const searchData = ref<ICharity[]>([]);
  function searchDataChange(list: ICharity[]) {
    if (!list.length) {
      alert({ title: t('No search results') });
      return;
    }
    searchData.value = list;
  }

  async function handleSubmit() {
    const points = currentPrize.point_cost;
    if (Number(authStore.user.points) < points) {
      toast.show({ title: t('Tips'), body: t('Not enough points') }, { variant: 'warning' });
      return;
    }
    await request.post('redemption_records', { prize_id: currentPrize.id });
    authStore.fetchData();
    dialogContent.show = false;
    alert({ title: t('Success'), content: t('review'), });
  }

  function handleCharitySubmited() {
    authStore.fetchData();
  }

  function charityUpdateFavored(data: ICharity) {
    const index = searchData.value.findIndex((item) => Number(item.id) === Number(data.id));
    if (index > -1) {
      searchData.value[index].favored = data.favored;
    }
  }

  onMounted(async () => {
    if (authStore.access_token) {
      authStore.tryFetchData();
    }
    settingStore.tryFetchData();
    await prizeCategoryStore.tryFetchData();
    Object.assign(currentPrizeCategory, prizeCategoryStore.data[0]);
    await updatePrize();
  });

return (_ctx: any,_cache: any) => {
  const _component_AppBreadcurmb = _resolveComponent("AppBreadcurmb")!
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")!
  const _component_b_dropdown = _resolveComponent("b-dropdown")!
  const _component_AppEmptyView = _resolveComponent("AppEmptyView")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppBreadcurmb, {
      routes: breadcurmbRoutes,
      style: {"margin":"2.3rem 0 2.6rem"}
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)('TerraCycle Recycling Rewards')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)('Your current have:')), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(authStore).user.points || 0), 1),
          _createElementVNode("span", null, _toDisplayString(_unref(t)('points')), 1)
        ])
      ]),
      (_unref(locale) === 'ja')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_12))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_18))
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("h1", _hoisted_21, _toDisplayString(_unref(t)('Redeem')), 1),
        (_unref(prizeCategoryStore).data.length)
          ? (_openBlock(), _createBlock(_component_b_dropdown, { key: 0 }, {
              "button-content": _withCtx(() => [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", null, _toDisplayString(_unref(currentPrizeCategory).name), 1),
                  _hoisted_23
                ])
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(prizeCategoryStore).data, (item, index) => {
                  return (_openBlock(), _createBlock(_component_b_dropdown_item, {
                    key: index,
                    onClick: ($event: any) => (handleChangeCategory(item))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_24, [
        (_unref(prizeStore).isEmpty)
          ? (_openBlock(), _createBlock(_component_AppEmptyView, { key: 0 }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(prizeStore).data, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "col-6 col-md-4"
          }, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("img", {
                src: item.images[0]?.url,
                class: _normalizeClass(["image", {pointer: item.partner_url}]),
                onClick: ($event: any) => (handlePrizeJump(item))
              }, null, 10, _hoisted_26),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", {
                  class: _normalizeClass(["point-name text-overflow-2", {pointer: item.partner_url}]),
                  onClick: ($event: any) => (handlePrizeJump(item))
                }, _toDisplayString(item.name), 11, _hoisted_28),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, _toDisplayString(item.point_cost), 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(t)('points')), 1)
                  ]),
                  (_unref(pointUsage))
                    ? (_openBlock(), _createBlock(_component_b_button, {
                        key: 0,
                        pill: "",
                        variant: "outline-primary",
                        onClick: ($event: any) => (handleShowPopup(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('Redeem')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        }), 128))
      ]),
      (_unref(locale) === 'ja')
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_35))
        : (_openBlock(), _createElementBlock("div", _hoisted_36, _hoisted_40)),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("h2", _hoisted_42, _toDisplayString(_unref(t)('Search for an existing charity')), 1),
        _createElementVNode("div", _hoisted_43, [
          _createVNode(SearchCharity, { onSearch: searchDataChange }),
          _createVNode(Charity, {
            list: searchData.value,
            points: _unref(authStore).user.points,
            "point-usage": _unref(pointUsage),
            "min-donate-points": _unref(settingStore).data.min_donate_points,
            onSubmited: handleCharitySubmited,
            onUpdateFavored: charityUpdateFavored
          }, null, 8, ["list", "points", "point-usage", "min-donate-points"])
        ]),
        _createElementVNode("div", _hoisted_44, [
          (_unref(locale) === 'ja')
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
            : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                _hoisted_49,
                _createVNode(_component_router_link, {
                  to: { name: 'charity.new' },
                  class: "link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_50
                  ]),
                  _: 1
                }, 8, ["to"])
              ])),
          _createElementVNode("div", {
            class: _normalizeClass(["col-12 col-md-3 col-xl-2", { 'ja-nenew-charity-btn-wrapper': _unref(locale) === 'ja' }])
          }, [
            _createVNode(_component_b_button, {
              pill: "",
              variant: _unref(ColorVariants).primary,
              to: { name: 'charity.new' },
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('Add new charity')), 1)
              ]),
              _: 1
            }, 8, ["variant", "to"])
          ], 2)
        ])
      ]),
      (_unref(locale) === 'ja')
        ? (_openBlock(), _createElementBlock("div", _hoisted_51, _hoisted_54))
        : (_openBlock(), _createElementBlock("div", _hoisted_55, _hoisted_58))
    ]),
    _createVNode(_component_AppDialog, {
      visible: _unref(dialogContent).show,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_unref(dialogContent).show) = $event)),
      title: _unref(t)('Current Points Balance'),
      "btn-text": _unref(t)('Redeem points'),
      onConfirm: handleSubmit
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_59, [
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("span", _hoisted_61, _toDisplayString(_unref(authStore).user.points), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(t)('points')), 1)
          ]),
          _createElementVNode("div", _hoisted_62, [
            (_unref(locale) === 'ja')
              ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                  _createElementVNode("strong", null, _toDisplayString(_unref(currentPrize).point_cost), 1),
                  _hoisted_64
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", null, [
                    _hoisted_65,
                    _createElementVNode("strong", null, _toDisplayString(_unref(currentPrize).point_cost), 1),
                    _hoisted_66
                  ]),
                  _hoisted_67
                ], 64))
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "title", "btn-text"])
  ]))
}
}

})